<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-form >
                            <v-checkbox v-model="checkboxes.cb_what"
                                        :label="$vuetify.lang.t('$vuetify.default_lrma.what_label')"
                                        :disabled="formDisabled"
                            ></v-checkbox>
                            <v-checkbox v-model="checkboxes.cb_how"
                                        :label="$vuetify.lang.t('$vuetify.default_lrma.how_label')"
                                        :disabled="formDisabled"
                            ></v-checkbox>
                            <v-checkbox v-model="checkboxes.cb_risks"
                                        :label="$vuetify.lang.t('$vuetify.default_lrma.risks_label')"
                                        :disabled="formDisabled"
                            ></v-checkbox>
                            <v-checkbox v-model="checkboxes.cb_control"
                                        :label="$vuetify.lang.t('$vuetify.default_lrma.control_label')"
                                        :disabled="formDisabled"
                            ></v-checkbox>
                            <three-state-cb
                                    v-if="dynamicQuestion"
                                    :checkbox_id="'DQI'"
                                    @3SCBChanged="threeStateSBChanged"
                                    :label="dynamicQuestion.question"
                                    :cb_type="'DQI'"
                                    ref="dynamicQuestion"
                                    :state="checkboxes.cb_pbm"
                                    :disabled="formDisabled"
                            ></three-state-cb>
                            <v-alert :icon="false" :type="(canStartWorking)?'success':'warning'" >
                                <p v-if="canStartWorking" class="text-center"> {{$vuetify.lang.t('$vuetify.default_lrma.lmra_job_state_positive')}}</p>
                                <p v-else class="text-center"> {{$vuetify.lang.t('$vuetify.default_lrma.lmra_job_state_negative')}}</p>
                            </v-alert>
                            <v-btn block color="primary"  @click.prevent="openRemarks()" :disabled="formDisabled" >
                                {{$vuetify.lang.t('$vuetify.global.confirmAndSend')}}
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <remarks-popup :initial_remarks="user_remarks" :is-visible="showRemarksPopup" :max-length="255" @closed="closePopup" :disabled="formDisabled"></remarks-popup>
        <locationPopup :is-visible="showPrivateLocationPopup" @checkComplete="save"></locationPopup>
    </v-container>
</template>

<script>
    import {mobileCheckMixin} from "../../../mixins/MobileCheckMixin/MobileCheckMixin";
    import ThreeStateCheckboxComponent from "../global/three-state-checkbox/ThreeStateCheckboxComponent";
    import RemarksInputComponent from "../global/remarksInput/RemarksInputComponent";
    import PrivateLocationCheckComponent from '../global/privateLocationChecker/PrivateLocationCheckComponent';
    import DynamicQuestionMixinForLMRA from "../../../mixins/dynamicQuestionMixinForLMRA/DynamicQuestionMixinForLMRA";
    import {ENTRY_DATA_KEY, LMRADataObjectHelper, WORK_STATE_START} from "@/api/repository/helpers/LMRADataObjectHelper";
    import lmraDataRepositoryApi from "@/api/repository/lmraDataRepositoryApi";
    import LmraVariantWorkSessionMixin from "@/workSessions/mixins/LmraVariantWorkSessionMixin";
    import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";

    export default {
        name: "defaultLmraComponent",
        mixins: [mobileCheckMixin, DynamicQuestionMixinForLMRA, LmraVariantWorkSessionMixin],
        data: () => {
            return {
                user_id : null,
                formDisabled : false,
                checkboxes: {
                    cb_what: false,
                    cb_how: false,
                    cb_risks: false,
                    cb_control: false,
                    cb_pbm: -1,
                },
                showRemarksPopup: false,
                showPrivateLocationPopup : false,
                user_remarks: '',
            }
        },
        components: {
            threeStateCb: ThreeStateCheckboxComponent,
            remarksPopup: RemarksInputComponent,
            locationPopup : PrivateLocationCheckComponent
        },
        methods: {
            openRemarks() {
                //console.log('CLICK');
                //console.log(this.checkboxes.cb_pbm)
                this.showRemarksPopup = true;
            },
            threeStateSBChanged($event) {
                //console.log('Received data:');
                //console.log($event);
                if ($event.id === 'DQI') {
                    //console.log('changing state');
                    this.checkboxes.cb_pbm = $event.state;
                }
            },
            closePopup($event){
                this.showRemarksPopup = false;
                this.user_remarks = $event.remarks;
                if($event.userConfirmed){
                    this.showPrivateLocationPopup = true;
                }
            },
           async save(){
                    this.formDisabled = true;
                    this.showPrivateLocationPopup = false;

                    let dataObject  = await LMRADataObjectHelper.buildBaseLmraDataObject();
                    dataObject[ENTRY_DATA_KEY]['what'] = this.checkboxes.cb_what;
                    dataObject[ENTRY_DATA_KEY]['how'] = this.checkboxes.cb_how;
                    dataObject[ENTRY_DATA_KEY]['risks'] = this.checkboxes.cb_risks;
                    dataObject[ENTRY_DATA_KEY]['control'] = this.checkboxes.cb_control;
                    dataObject[ENTRY_DATA_KEY]['pbm'] = this.checkboxes.cb_pbm;
                    dataObject[ENTRY_DATA_KEY]['pbm_question'] = this.dynamicQuestion;
                    dataObject[ENTRY_DATA_KEY]['remarks'] = this.user_remarks;
                    dataObject[ENTRY_DATA_KEY]['work_state'] = WORK_STATE_START;
                    //TRY SENDING THE TEMP SESSION!

                    /* START SENDING PART (DIFFERENT THAN OTHERS!!) */

                    //console.log(dataObject);

                    await lmraDataRepositoryApi.sendBasicLmra(dataObject)
                        .then(response => {
                            this.handleLMRAVariantServerResponse(response.data);
                        })
                        .catch(err => {
                            sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(this.$vuetify.lang.t('$vuetify.errors.data_save_failed') + ' err: ' + err.message);
                            this.formDisabled = false;
                        });
                    /* END SENDING PART */
            },
        },
        computed: {
            canStartWorking() {
                if (
                    this.checkboxes.cb_what &&
                    this.checkboxes.cb_how &&
                    this.checkboxes.cb_risks &&
                    this.checkboxes.cb_control &&
                    (this.checkboxes.cb_pbm === 1 || this.checkboxes.cb_pbm === 0)
                ) {
                    return true;
                }
                return false;
            }
        },
        async created() {
            this.user_id = this.$store.getters.getUserId;
            await this.getNewDynamicQuestion();
        }
    }
</script>

<style lang="scss">
    .v-input__slot{
        display: inline-block;
        label{
            top:-3px;
        }
    }

</style>